import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  signal
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {MultiDomainMgmtService} from 'src/app/services/multi-domain-mgmt.service';
import {environment} from '../../../environments/local/environment';

@Component({
  selector: 'app-no-app-permission',
  templateUrl: './no-app-access.component.html',
  styleUrls: ['./no-app-access.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoAppAccessComponent implements OnInit, OnDestroy {
  readonly description = signal('');

  private readonly subscriptions = new Subscription();

  constructor(
    private multiDomainMgmtService: MultiDomainMgmtService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.multiDomainMgmtService.getSharedMultiDomainProfile(true).subscribe({
        next: profile => {
          if (profile) {
            const activeDomain = profile.domains.find(d => d.active);

            if (activeDomain) {
              this.description.set(
                this.translateService.instant('OAUTH.NO_ACCESS.DESCRIPTION', {
                  companyName: activeDomain.companyName
                })
              );
            }
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  goToMHP(): void {
    window.open(environment.links.applications.hcp, '_self');
  }
}